module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ui-button",
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [(_vm.iconLeft) ? _c('ui-icon', {
    staticClass: "ui-button__icon left",
    attrs: {
      "name": _vm.iconLeft
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default", [_vm._t("title", [_vm._v(_vm._s(_vm.title))], {
    tag: "span"
  })]), _vm._v(" "), (_vm.iconRight) ? _c('ui-icon', {
    staticClass: "ui-button__icon left",
    attrs: {
      "name": _vm.iconRight
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28e22127","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/universal/UiButton.vue
// module id = 436
// module chunks = 1